import styled, { css } from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';

const SHADOW = '0 0.125rem 0.625rem 0 rgba(0,0,0,0.07)';
const base10 = baseVariables?.color?.base10 ?? '#1c1c1c';

export const ArrowButton = styled.button<{ $transparent: boolean }>`
  --icon-color: var(--t-color-control-foreground, ${base10});
  --drop-shadow: ${SHADOW};
  display: flex;
  align-items: center;
  justify-content: center;
  block-size: 2.5rem;
  inline-size: 2.5rem;
  padding: 0;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  color: var(--icon-color);
  transition: background-color 300ms ease-out, backdrop-filter 300ms ease-out, box-shadow 300ms ease-out,
    color 300ms ease-out;

  ${({ $transparent }) =>
    $transparent
      ? css`
          background-color: color-mix(in srgb, var(--t-color-control-background, ${base10}) 55%, transparent);
          backdrop-filter: blur(2px);
          box-shadow: none;

          &:hover:not(:disabled) {
            background-color: var(--t-color-control-background, ${base10});
            box-shadow: var(--drop-shadow);
            backdrop-filter: none;
          }
        `
      : css`
          background-color: var(--t-color-control-background, ${base10});
          box-shadow: var(--drop-shadow);
        `}

  &:focus:not(:disabled) {
    outline: 2px solid -webkit-focus-ring-color;
  }

  &:disabled {
    --icon-color: color-mix(in srgb, var(--t-color-control-foreground, ${base10}) 50%, transparent);
    cursor: not-allowed;
  }

  .icon {
    color: var(--icon-color);
  }
`;
